export const PAGE_SUITE_EVENTS = {
onLaunch: "com.pagesuite.editionLaunch",
onPageView: "com.pagesuite.pageView",
onPageRendered: "com.pagesuite.pageRendered",
onArticleView: "com.pagesuite.articleView",
onArticleRendered: "com.pagesuite.articleRendered",
}

export const PAGE_SUITE_PAGE_TYPES = {
    advertisement: "advert_third_party",
    replica: "replica_pdf_page",
    article: "templateArticle"
}

export type PAGE_SUITE_PAGE_LEVELS = "page" | "pdf" | "article";
    